import classnames from 'classnames';
import ColumnBox from 'components/Containers/ColumnBox';
import SpreadBox from 'components/Containers/SpreadBox';
import Label from 'components/form/Label/Label';
import HorizontalLine from 'components/Line/HorizontalLine';
import { ResponsiveModal } from 'components/Modals/ResponsiveModal';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { formatUSDwithCents } from 'helpers/money.helper';
import { STATE___NO_PAYMENT_MANAGEMENT } from 'pages/Cash/pages/BuilderHome/builder.helper';
import React from 'react';
import { ReactComponent as ArrowUp } from 'style/icons/lg-chevron-up.svg';
import { ReactComponent as ArrowDown } from 'style/icons/lg-chevron-down.svg';

const BuilderBalanceRow = props => {
  return (
    <SpreadBox onClick={props.onClick} className={props.paddingClass}>
      <Label type="Body-1">{props.title}</Label>
      <Label type={classnames('Subtitle-1 ', { notBold: props.notBold })}>
        {props.isNegative && '-'}
        {formatUSDwithCents(props.value)} {props.arrowIcon}
      </Label>
    </SpreadBox>
  );
};
const BuilderBalanceModal = props => {
  const isUtilizationSet =
    props?.builderManager.highLevelState !== STATE___NO_PAYMENT_MANAGEMENT;

  const spendableBalance = props?.builderManager?.spendableBalance;
  const securedBuilderBalance = props.builderManager?.securedBuilderBalance;
  const utilizedBuilderBalance = props.builderManager?.utilizedBuilderBalance;
  const reservedBuilderPayment = props?.builderManager?.reservedBuilderPayment;
  const totalBuilderBalance = props?.builderManager?.totalBuilderAccountBalance;
  const totalCashBalance = props?.builderManager?.totalCashBalance;

  /*
  state?.debitCard?.creditLimit + state?.creditPurse?.balance - props?.builderManager?.debitCard?.balance
   */
  return (
    <ResponsiveModal
      visible={props.visible}
      centered={true}
      wrapClassName="noFooter"
      closable={true}
      onCancel={props.onCloseClick}
      footer={null}
      header={''}
    >
      <Label type={'H4'} className="padB16">
        Sesame Cash Balance
      </Label>
      <HorizontalLine />
      <BuilderBalanceRow
        title="Spendable Balance"
        paddingClass="padTB16"
        value={spendableBalance}
      />
      <BuilderBalanceRow
        title={
          <Label>
            Total Builder Balance
            {!isUtilizationSet && (
              <CSTooltip
                title={`This is the money you allocated to build your credit history. 
                This is still your cash—it's just set aside to help grow your 
                score until you're ready to use it. You can increase the amount 
                at any time, or access your money within settings. `}
                placement="bottom"
                isInline
              />
            )}{' '}
          </Label>
        }
        paddingClass="padB16"
        value={totalBuilderBalance}
        onClick={!isUtilizationSet || props.toggleDropdown}
        arrowIcon={
          <span className={classnames({ poof: !isUtilizationSet })}>
            {props.isDropDownOpen ? (
              <ArrowUp aria-label={'ArrowUp'} />
            ) : (
              <ArrowDown aria-label={'ArrowDown'} />
            )}
          </span>
        }
      />
      {props.isDropDownOpen && (
        <ColumnBox>
          <BuilderBalanceRow
            title={
              <Label type="Body-2">
                <span className="padL16" />
                Secured Builder Balance
                <CSTooltip
                  title={`This is the money you allocated to build your credit history. 
                This is still your cash—it's just set aside to help grow your 
                score until you're ready to use it. You can increase the amount 
                at any time, or access your money within settings. `}
                  placement="bottom"
                  isInline
                />{' '}
              </Label>
            }
            notBold
            paddingClass="padB16"
            value={securedBuilderBalance}
          />
          <BuilderBalanceRow
            title={
              <Label type="Body-2">
                <span className="padL16" />
                Utilized Builder Balance
                <CSTooltip
                  title={`As you make eligible debit purchases with Sesame Cash, we'll 
                create your Utilized Builder Balance. This is the amount we'll 
                report the major bureaus each month. Your Utilized Builder Balance 
                will fluctuate as we automatically move purchases to meet the 
                limit you selected, and pay your balance.`}
                  placement="bottom"
                  isInline
                />{' '}
              </Label>
            }
            paddingClass="padB16"
            isNegative
            notBold
            value={utilizedBuilderBalance}
          />
          <BuilderBalanceRow
            title={
              <Label type="Body-2">
                <span className="padL16" />
                Reserved Builder Payment
                <CSTooltip
                  title={`As we add debit purchases to your Utilized Builder Balance, 
                we'll allocate the same amount to your Reserved Builder Payment. 
                Behind the scenes, this is used to automatically pay your full 
                monthly balance—at no additional cost to you. You can always 
                withdraw your reserved payment under settings.`}
                  placement="bottom"
                  isInline
                />{' '}
              </Label>
            }
            notBold
            paddingClass="padB16"
            value={reservedBuilderPayment}
          />
        </ColumnBox>
      )}
      <HorizontalLine />
      <BuilderBalanceRow
        title="Total Account Balance"
        paddingClass="padTB16"
        value={totalCashBalance}
      />
      <HorizontalLine />
    </ResponsiveModal>
  );
};

export default BuilderBalanceModal;
